import React, { FC } from 'react';
import { KTSVG } from 'src/_metronic/helpers';

// Sohbet ikonları — Metronic duotone SVG'leri KTSVG ile. Yollar merkezi.
export const CHAT_ICON_PATHS: Record<string, string> = {
  search: '/media/icons/duotone/General/Search.svg',
  plus: '/media/icons/duotone/Navigation/Plus.svg',
  smile: '/media/icons/duotone/General/Smile.svg',
  clip: '/media/icons/duotone/General/Clip.svg',
  send: '/media/icons/duotone/Communication/Send.svg',
  close: '/media/icons/duotone/Navigation/Close.svg',
  info: '/media/icons/duotone/Code/Info-circle.svg',
  chat: '/media/icons/duotone/Communication/Chat.svg',
  chatSmile: '/media/icons/duotone/Communication/Chat-smile.svg',
  groupChat: '/media/icons/duotone/Communication/Group-chat.svg',
  edit: '/media/icons/duotone/General/Edit.svg',
  trash: '/media/icons/duotone/General/Trash.svg',
  stop: '/media/icons/duotone/Code/Stop.svg',
  doubleCheck: '/media/icons/duotone/Navigation/Double-check.svg',
  check: '/media/icons/duotone/Navigation/Check.svg',
  doneCircle: '/media/icons/duotone/Code/Done-circle.svg',
  clock: '/media/icons/duotone/Home/Clock.svg',
  addUser: '/media/icons/duotone/Communication/Add-user.svg',
  signOut: '/media/icons/duotone/Navigation/Sign-out.svg',
};

interface Props {
  name: keyof typeof CHAT_ICON_PATHS | string;
  className?: string;
  svgClassName?: string;
}

export const ChatIcon: FC<Props> = ({ name, className = '', svgClassName }) => (
  <KTSVG path={CHAT_ICON_PATHS[name] || name} className={className} svgClassName={svgClassName} />
);
